import React from 'react';
import { Bot, User, Loader2 } from 'lucide-react';
import { ChatVisualization } from './ChatVisualization';

export const ChatMessage = ({ msg, index }) => (
  <div
    key={index}
    className={`flex gap-3 ${msg.role === 'user' ? 'flex-row-reverse' : ''}`}
    data-testid={`chat-message-${index}`}
  >
    <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 ${
      msg.role === 'user' ? 'bg-[#E3000F]' : 'bg-[#27272A]'
    }`}>
      {msg.role === 'user' ? <User className="w-4 h-4" /> : <Bot className="w-4 h-4" />}
    </div>
    <div className={`max-w-[85%] md:max-w-[70%] p-4 ${
      msg.role === 'user'
        ? 'bg-[#E3000F]/20 border border-[#E3000F]/30'
        : 'bg-[#1A1A1A] border border-[#27272A]'
    }`}>
      <p className="text-sm whitespace-pre-wrap">{msg.content}</p>
      {msg.visualization && <ChatVisualization visualization={msg.visualization} />}
    </div>
  </div>
);

export const ChatLoading = () => (
  <div className="flex gap-3">
    <div className="w-8 h-8 bg-[#27272A] flex items-center justify-center flex-shrink-0">
      <Bot className="w-4 h-4" />
    </div>
    <div className="bg-[#1A1A1A] border border-[#27272A] p-4">
      <Loader2 className="w-5 h-5 animate-spin text-[#E3000F]" />
    </div>
  </div>
);

export const SuggestedQuestions = ({ onSelect }) => {
  const questions = [
    "Mostra una mappa di tutti gli interventi",
    "Grafico interventi per tipo",
    "Tabella riassuntiva degli interventi",
    "Riassumi l'ultimo intervento"
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-testid="suggested-questions">
      {questions.map((q, i) => (
        <button
          key={i}
          onClick={() => onSelect(q)}
          className="text-left p-3 bg-[#1A1A1A] border border-[#27272A] hover:border-[#E3000F] text-sm transition-colors"
          data-testid={`suggested-q-${i}`}
        >
          {q}
        </button>
      ))}
    </div>
  );
};
